
import  { useState, useEffect, useRef,useMemo,useCallback } from "react";
import AddMember from './AddMember';
import MemberCard from './MemberCard';
import { getFacilityId } from '../../utils/format';

const ScheduleTabs = ({ schedule, onAddMember, onTabChange, onCheckinCountUpdated }) => {
  // State to track the selected tab
  const [selectedTab, setSelectedTab] = useState(0); // Default to first tab

  //===========Pull to refresh code======================
  const [startPoint, setStartPoint] = useState(0);
  const [pullChange, setPullChange] = useState();
  const refreshCont = useRef(0);

  const initLoading = () => {
    refreshCont.current.classList.add("loading");
    onAddMember()
  };

  const pullStart = (e) => {
    const { screenY } = e.targetTouches[0];
    setStartPoint(screenY);
  };

  useEffect(() => {
  window.addEventListener("touchstart", pullStart, { passive: true });
  window.addEventListener("touchmove", pull, { passive: true });
  window.addEventListener("touchend", endPull);

    return () => {
      window.removeEventListener("touchstart", pullStart);
      window.removeEventListener("touchmove", pull);
      window.removeEventListener("touchend", endPull);
    };
  }, []);

  const pullChangeRef = useRef(0);
  const pull = (e) => {
    const { screenY } = e.targetTouches[0];
    pullChangeRef.current = startPoint < screenY ? screenY - startPoint : 0;
  };

  const endPull = () => {
  if (pullChangeRef.current > 220) initLoading();
  pullChangeRef.current = 0;
};


  //===========Pull to refresh code======================

  const selectedSchedule = schedule[selectedTab];

  const bookedMembers = useMemo(() => {
    return selectedSchedule?.members
      ?.filter(m => m && m.status === "Booked")
      .sort((a, b) => a.firstname.localeCompare(b.firstname)) || [];
  }, [selectedSchedule]);


  const checkedInMembersCount = useMemo(
    () => bookedMembers.filter(m => m.checkedin === "Yes").length,
    [bookedMembers]
  );

  const bookedCount = bookedMembers.length;



  const handleTabChange = useCallback((index, className) => {
  setSelectedTab(index);
  onTabChange?.(index, className);
}, [onTabChange]);



  useEffect(() => {
    if (schedule.length > 0) {
      handleTabChange(selectedTab, schedule[selectedTab]?.class_name || '');
    }
  }, [schedule, selectedTab]);

  

  return (
    <div className="">
      {/* Vertical Tabs */}
      <div className="mb-4 ">
        <div className=" flex flex-wrap pb-2 px-4 gap-4">
          {schedule && schedule.length > 0 && schedule.filter(daySchedule => daySchedule !== null)
          .map((daySchedule, index) => (
            <button
              key={daySchedule.id}
              onClick={() => handleTabChange(index, daySchedule.class_name)} // Change the selected tab
              className={` text-left py-1 px-3 rounded-full hover:bg-[#e00000] hover:text-white ${selectedTab === index
                  ? "bg-[#e00000] text-white"
                  : "text-gray-700 bg-[#e0e1e2]"
                }`}
            >
              {daySchedule?.start_time}
            </button>
          ))}
        </div>
      </div>

      {/* Schedule Details */}
      <div className="w-full bg-white p-6 rounded-lg shadow-md min-h-screen">
        <div
          ref={refreshCont}
          className="refresh-container w-fit -mt-10 hidden m-auto"
          style={{ marginTop: pullChange / 3.118 || "", display: pullChange > 0 ? "block" : "none" }}
        >
          <div className="refresh-icon p-2 rounded-full">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="#e00000"
              className="w-6 h-6"
              style={{ transform: `rotate(${pullChange}deg)` }}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
              />
            </svg>
          </div>
        </div>
        {schedule[selectedTab] ? (

          <div className="px-4">
            <AddMember
              checkedInMembersCount={checkedInMembersCount}
              calendarScheduleTime ={schedule[selectedTab].start_time}
              calendarScheduleId={schedule[selectedTab].id}
              calendarDisciplineId={schedule[selectedTab].discipline_id}
              addMember={onAddMember}
              bookedCount={bookedCount}
              bookCapacity={schedule[selectedTab].capacity}
              waitingCount={schedule[selectedTab].waiting_list}
              waitingCapacity={schedule[selectedTab].waiting_capacity}
            />
            <ul className="space-y-4 pt-4">
              {schedule[selectedTab].members &&
                schedule[selectedTab].members.length > 0 ? (
                [...schedule[selectedTab].members] 
                  .filter((member) => member !== null && member.status === "Booked")
                  .sort((a, b) => a.firstname.localeCompare(b.firstname)) 
                  .map((member) => (
                    <li
                      key={member.id}
                      className="flex items-center space-x-4 rounded-md"
                    >
                      <MemberCard
                        key={member.id}
                        member={member}
                        facilityId={getFacilityId()}
                        calendarScheduleId={schedule[selectedTab].id}
                        disciplineId={schedule[selectedTab].discipline_id}
                        handleCheckInCount={onCheckinCountUpdated}
                      />
                    </li>
                  ))
              ) : (
                <p>No members scheduled</p>
              )}
            </ul>
          </div>
        ) : (
          <p></p>
        )}
      </div>
    </div>
    
  );
  
};

export default ScheduleTabs;
